<script setup lang="ts">
import { computed } from 'vue'

import TooltipComponent from './TooltipComponent.vue'
import TypographyComponent from './TypographyComponent.vue'

const props = defineProps<{
  content: string
  tooltipContent?: string
  percentage: number
  hasLimit?: boolean
  limit?: number
}>()

const width = computed(() => `${props.percentage}%`)
const limitProgressWidth = computed(() => `${props.limit ?? 0}%`)
const isDanger = computed(() => {
  const limitExceeded = props.hasLimit && props.limit && props.percentage > props.limit
  return props.percentage >= 100 || limitExceeded
})
</script>
<template>
  <div>
    <TooltipComponent :disabled="!tooltipContent" placement="bottom" effect="light" :show-arrow="false">
      <div :class="['progress', { darkened: hasLimit }]">
        <div :class="['progress__inner', { danger: isDanger }]" />
        <div class="progress__limited" />
        <TypographyComponent variant="label-small" text-align="center" color="var(--inverted)" class="progress__content">
          {{ content }}
        </TypographyComponent>
      </div>
      <template v-if="tooltipContent" #content>{{ tooltipContent }}</template>
    </TooltipComponent>
  </div>
</template>
<style lang="scss" scoped>
.progress {
  min-width: 88px;
  height: 16px;
  border-radius: 48px;
  position: relative;
  overflow: hidden;
  background-color: #b8b8b8;

  &.darkened {
    background-color: var(--secondary-48);
  }
}
.progress__inner {
  position: absolute;
  left: 0;
  top: 0;
  width: v-bind(width);
  height: 100%;
  background-color: var(--success);
  border-radius: 0;
  z-index: 2;

  &.danger {
    background: var(--alert);
  }
}
.progress__content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
}

.progress__limited {
  position: absolute;
  left: 0;
  top: 0;
  width: v-bind(limitProgressWidth);
  height: 100%;
  background-color: var(--secondary-18);
}
</style>
